import { connect } from 'react-redux'
import { SigninSignupRouteComponent } from './SigninSignupRouteComponent'
import { fetchSigninPageData } from 'shared/store/signin'
import { fetchSignupPageData } from 'shared/store/signup'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'

const mapStateToProps = (state: RootState) => {
    const url = new URL(window.location.href)
    const searchParams = new URLSearchParams(url.search)
    const fromUrlFromSearchParams = searchParams.get('fromUrl')

    const isSearchParamRedirectValid =
        !!fromUrlFromSearchParams && !fromUrlFromSearchParams.startsWith('http') //only allow relative paths

    const fromUrl = isSearchParamRedirectValid
        ? fromUrlFromSearchParams
        : state.router.location.state && state.router.location.state.fromUrl

    const activeLeft =
        state.router.location.state && state.router.location.state.signUp
    return {
        fromUrl,
        activeLeft
    }
}

const mapDispatchToProps = (d: Dispatch) => ({
    fetchSigninPageData: () => d(fetchSigninPageData()),
    fetchSignupPageData: () => d(fetchSignupPageData())
})

const SigninSignupRoute = connect(
    mapStateToProps,
    mapDispatchToProps
)(SigninSignupRouteComponent)

export { SigninSignupRoute }
